type RouteParams = {
  [key: string]: string | number;
};

export const generateRoute = (route: string, params: RouteParams): string => {
  let generatedRoute = route;

  for (const paramKey of Object.keys(params)) {
    const paramValue = params[paramKey];
    generatedRoute = generatedRoute.replace(
      `:${paramKey}`,
      paramValue?.toString() ?? "",
    );
  }

  return generatedRoute;
};
